import React from 'react';
import { MapPin, Phone, Clock, Instagram } from 'lucide-react';

const WHATSAPP = '(73) 99192-3111';
const WHATSAPP_LINK = 'https://wa.me/5573991923111';
const INSTAGRAM_HANDLE = '@petiscariacamamu';
const INSTAGRAM_LINK = 'https://instagram.com/petiscariacamamu';

const Footer = () => {
  return (
    <footer className="bg-[#291014] text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/logo.png"
                alt="Petiscaria Camamu"
                className="h-14 w-14 object-contain"
                data-testid="footer-logo"
              />
              <h3
                className="text-2xl font-bold"
                style={{ fontFamily: 'Outfit, sans-serif' }}
                data-testid="footer-brand"
              >
                Petiscaria Camamu
              </h3>
            </div>
            <p
              className="text-white/80 mb-4"
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="footer-description"
            >
              Os melhores petiscos artesanais da região. Sabor e qualidade em cada mordida!
            </p>
            <div className="flex items-center gap-3">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-10 w-10 rounded-full bg-[#25D366] hover:bg-[#1ebd5a] text-white transition-all"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp-button"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
              <a
                href={INSTAGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-10 w-10 rounded-full text-white transition-all"
                style={{
                  background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                }}
                aria-label="Instagram"
                data-testid="footer-instagram-button"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-xl font-bold mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Contato
            </h4>
            <div className="space-y-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#EA580C] transition-colors"
                data-testid="footer-phone-link"
              >
                <Phone className="h-4 w-4 text-[#EA580C]" />
                <span className="text-white/80" data-testid="footer-phone">{WHATSAPP}</span>
              </a>
              <a
                href={INSTAGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#EA580C] transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram className="h-4 w-4 text-[#EA580C]" />
                <span className="text-white/80" data-testid="footer-instagram">{INSTAGRAM_HANDLE}</span>
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-[#EA580C] mt-1" />
                <span className="text-white/80" data-testid="footer-address">
                  Camamu - BA
                </span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4
              className="text-xl font-bold mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Horário de Funcionamento
            </h4>
            <div className="space-y-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-[#EA580C]" />
                <div className="text-white/80">
                  <p data-testid="footer-hours-weekday">Quinta a Segunda</p>
                  <p className="font-semibold">19h às 22h</p>
                </div>
              </div>
              <p className="text-white/60 text-sm" data-testid="footer-hours-closed">Fechado às terças e quartas</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p
            className="text-white/60 text-sm"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="footer-copyright"
          >
            © 2024 Petiscaria Camamu. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
